export const nextDayChecked = () => {
    $('input[name=shipModeId]:radio').change(function(event) {
        if ($('#next-day').prop("checked") == true) {
            $('.next-day-info').slideDown();
        } else {
            $('.next-day-info').slideUp();
        }
    });
};
